export const stripNonDigits = (value: string) => {
    return value.replace(/\D/g, "");
};
